;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();export default function CheckoutHeader() {
  return (
    <div className={" flex justify-center"}>
      <div
        className={
          "font-bebas text-white min-[800px]:text-[30px] text-[30px] tracking-[1.96px] min-[800px]:tracking-[2.1px] min-[800px]:m-[40px_0_25px_0] m-[18px_0_25px_0] max-w-[600px] min-[800px]:max-w-none grow grow"
        }
      >
        CHECKOUT
      </div>
    </div>
  )
}
